export default __webpack_public_path__ + "static/media/1775.7354af64.png";